import React from "react"
import {getPageData} from "../pageData"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import MbpHead from "../components/head/MbpHead"
import {useTranslation} from "next-i18next"
import NavBar from "../components/navigation/NavBar"
import Footer from "../components/footer/Footer"
import nextI18nextConfig from "../next-i18next.config"
import WishListContent from "../components/wishList/WishListContent"

function WishList() {
	const {t} = useTranslation()
	const title = t("wish-list-page-title")
	const description = t("wish-list-page-description")
	return (<>
		<MbpHead>
			<title>
				{title}
			</title>
			<meta name="description"
				content={description}/>
			<meta property="og:title"
				content={title}/>
			<meta property="og:description"
				content={description}/>
		</MbpHead>
		<NavBar />
		<WishListContent />
		<Footer/>
	</>
	)
}

export async function getStaticProps({locale}) {
	const pageData = (await getPageData(locale))
	return {
		props: {
			...pageData,
			...(await serverSideTranslations(locale, ["common", "homePage", "homeDetails", "productDescrPage", "checkout", "search", "filters", "insurance", "wishList"], nextI18nextConfig))
		}
	}
}

export default WishList
